import { Component, EventEmitter, Injector, Input, Output } from '@angular/core'
import { AppComponentBase } from '@shared/common/app-component-base';
import { InvoiceDtlItem } from 'QrMena/models/qrmena-invoice-model';
@Component({
    selector: "qrmena-invoice-item-record",
    templateUrl: './invoice-item-record.component.html',
    styleUrls: ['./invoice-item-record.component.css']
})
export class InvoiceItemRecordComponent extends AppComponentBase {
    @Input() invoiceItem: InvoiceDtlItem
    @Input() index:number
    @Output() handelRemoveItem:EventEmitter<string>=new EventEmitter<string>()
   @Output() handelChangeQty:EventEmitter<{qty:number,recordId:string}>=new EventEmitter<{qty:number,recordId:string}>()
    constructor(injector: Injector,) {
        super(injector);

    }

    handelIncrementQty() {
        this.invoiceItem.quantity++
         this.handelChangeQty.emit({qty:this.invoiceItem.quantity,recordId:this.invoiceItem.id})
    }
    handelDecrementQty() {
        this.invoiceItem.quantity--
        if (this.invoiceItem.quantity == 0) {
            this.handelRemoveItemClick()
        }else{
            this.handelChangeQty.emit({qty:this.invoiceItem.quantity,recordId:this.invoiceItem.id})
        }
        
    }
    handelRemoveItemClick() {
        this.handelRemoveItem.emit(this.invoiceItem.id)
    }
}


// WEBPACK FOOTER //
// ./src/QrMena/components/invoice-item-record-component/invoice-item-record.component.ts